import { render, staticRenderFns } from "./SortIcon.vue?vue&type=template&id=49a69430"
import script from "./SortIcon.vue?vue&type=script&lang=js"
export * from "./SortIcon.vue?vue&type=script&lang=js"
import style0 from "./SortIcon.vue?vue&type=style&index=0&id=49a69430&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports